import React from 'react'
import { ChevronDown } from 'lucide-react'
import { DropdownMenu } from '../dropdown_menu'

const CATEGORY_LABEL = {
  MARKETING: 'Marketing',
  UTILITY: 'Utility',
  AUTHENTICATION: 'Auth',
}

class SelectTemplate extends React.Component {

  onTemplateClick = (templateValue) => {
    this.props.onSelect(templateValue)
  }

  render() {
    const items = this.props.templates
      .filter((template) => !(template.value === 'draft' && this.props.disableDraft))
      .map((template) => {
        const label = CATEGORY_LABEL[template.category]
        return label ? { ...template, name: `${template.name} — ${label}` } : template
      })

    return (
      <DropdownMenu
        buttonClassName="btn-outline btn-sm"
        className="dropdown-menu-right"
        items={items}
        onItemClick={this.onTemplateClick}
        searchable
      >
        Template <ChevronDown className="size-3.5"/>
      </DropdownMenu>
    )
  }
}

export default SelectTemplate
